// src/hooks/useCountdown.ts
import { useCallback, useEffect, useState } from "react";

import {
  MS_IN_SECOND,
  SECONDS_IN_DAY,
  SECONDS_IN_HOUR,
  SECONDS_IN_MINUTE,
} from "@/constants/shared";

export const getTimeUntilTarget = (targetDate: Date) => {
  const now = new Date();
  return Math.max(
    Math.floor((targetDate.getTime() - now.getTime()) / MS_IN_SECOND),
    0,
  );
};

export const useCountdown = (targetDate?: Date) => {
  const calculateSecondsLeft = useCallback(() => {
    if (targetDate) {
      return getTimeUntilTarget(targetDate);
    }
    const midnightUTC = new Date(
      Date.UTC(
        new Date().getUTCFullYear(),
        new Date().getUTCMonth(),
        new Date().getUTCDate() + 1,
      ),
    );
    return getTimeUntilTarget(midnightUTC);
  }, [targetDate]);

  const [secondsLeft, setSecondsLeft] = useState(calculateSecondsLeft());

  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsLeft(calculateSecondsLeft());
    }, 1000);

    return () => clearInterval(interval);
  }, [calculateSecondsLeft, targetDate]);

  const days = Math.floor(secondsLeft / SECONDS_IN_DAY);
  const hours = Math.floor(secondsLeft / SECONDS_IN_HOUR);

  const minutes = Math.floor(
    (secondsLeft % SECONDS_IN_HOUR) / SECONDS_IN_MINUTE,
  );
  const seconds = secondsLeft % 60;

  return {
    days: String(days).padStart(2, "0"),
    hours: String(hours).padStart(2, "0"),
    minutes: String(minutes).padStart(2, "0"),
    seconds: String(seconds).padStart(2, "0"),
    isComplete: secondsLeft === 0,
  };
};
